export enum AugloopEvent {
  SessionConnect = 'SessionConnect',
  SessionDisconnect = 'SessionDisconnect',
  SessionReconnect = 'SessionReconnect',
  SessionClose = 'SessionClose',
  SessionReConnectFailed = 'SessionReConnectFailed'
}

export interface IAugloopEventEmitter {
  // Register the callback to be called every time the event is emitted
  on(event: AugloopEvent, callback: () => void): void,

  // Register the callback to be called the next time the event is emitted
  once(event: AugloopEvent, callback: () => void): void,

  // Emit the event
  emit(event: AugloopEvent): void,

  // Remove listener
  removeListener(event: AugloopEvent, listener: any): void
}